import { Metrics } from './metrics';
import { rhumbAggregator } from './rhumbAggregator';
import { ON_ATTACH, ON_DATA } from '../links/definition/link';
export const timing = {
  // Top-level lifecycle operations. Each is a single user-visible unit of work
  // and never nests inside another, so summing their durations into the rhumb
  // aggregator yields total Pulse time without double-counting.
  timeAttach(duration) {
    Metrics.timer('lifecycleManager.attach').update(duration);
    rhumbAggregator.accumulate('attach', duration);
  },
  timeDetach(duration) {
    Metrics.timer('lifecycleManager.detach').update(duration);
    rhumbAggregator.accumulate('detach', duration);
  },
  timeStateChange(duration) {
    Metrics.timer('lifecycleManager.handleStateChange').update(duration);
    rhumbAggregator.accumulate('stateChange', duration);
  },
  timeInvalidate(duration) {
    Metrics.timer('lifecycleManager.invalidate').update(duration);
    rhumbAggregator.accumulate('invalidate', duration);
  },
  timeInvalidateAll(duration) {
    Metrics.timer('lifecycleManager.invalidateAll').update(duration);
    rhumbAggregator.accumulate('invalidate', duration);
  },
  timeCollectNode(duration) {
    Metrics.timer('collectNode').update(duration);
    rhumbAggregator.accumulate('gc', duration);
  },
  timeResync(duration) {
    Metrics.timer('lifecycleManager.resync').update(duration);
    rhumbAggregator.accumulate('resync', duration);
  },
  // Sub-operations. These run inside a top-level operation, so they only
  // emit individual metrics — accumulating them into rhumb would double-count.
  timeSyncLinks(duration) {
    Metrics.timer('syncNodeLinks').update(duration);
  },
  timeSyncTags(duration, hasData) {
    Metrics.timer('syncTags', {
      timing: hasData ? ON_DATA : ON_ATTACH
    }).update(duration);
  },
  timeRegisterNode(duration) {
    Metrics.timer('registerNode').update(duration);
  }
};